"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrlWithoutHashParams = void 0;
/**
 * Returns the current URL without any hash params, preserving query params
 */
function getUrlWithoutHashParams() {
    return window.location.href.split('#')[0];
}
exports.getUrlWithoutHashParams = getUrlWithoutHashParams;
//# sourceMappingURL=url_without_hash_params.js.map